/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * The version of the OpenAPI document: 1.0.31
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Psychological category (area)
 */
export interface Category { 
    id: number;
    uuid: string;
    /**
     * Absolute path in material portal to active icon of this category
     */
    activeIconUrl: string;
    /**
     * Absolute path in material portal to inactive icon of this category
     */
    inactiveIconUrl: string;
    /**
     * Color in HEX format, e.g. #E02D2D
     */
    color: string;
    name: string;
}

